import React, { useState } from "react";
import PropTypes from "prop-types";
import { motion, AnimatePresence } from "framer-motion";
import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import TableSortLabel from "@mui/material/TableSortLabel";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import Input from "@mui/material/Input";
import InputAdornment from "@mui/material/InputAdornment";
import { visuallyHidden } from "@mui/utils";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import Drawer from "@mui/material/Drawer";
import ConfirmBox from "../../../UiComponents/ConfirmBox/ConfirmBox";
import Switch from "@mui/material/Switch";
import DeleteImage from "../../../../src/Resources/Images/delete_common.png";
import DisabledImage from "../../../../src/Resources/Images/disable.png";
import ActiveImage from "../../../../src/Resources/Images/ActiveImage.png";
import CustomTooltip from "./Tooltip";
import Modal from "@mui/material/Modal";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";

import {
  EditIcon,
  AddIcon,
  DeleteIcon,
  SearchIcon,
  NotInterestedIcon,
  CloudOffIcon,
  DoneOutlineIcon,
} from "../../../Resources/Icons/icons";
import {
  GetCompanyRTO,
  UpdateBranch,
  DeleteRTO,
  GetCompanyRTOByID,
  UpdateCompanyRTO,
} from "../../../Service/_index";
import Loader from "../../../UiComponents/Loader/Loader";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import AddRTOMapping from "./AddRTOMapping";
import moment from "moment";
import { Transition } from "../../../UiComponents/Transition/Transition";
import { Divider } from "@mui/material";
import TabFilter from "../../../Components/Tabs/Tabs";
import MasterCommonTable from "../../../UiComponents/CommonTable/MasterCommonTable";
import { grey } from "@mui/material/colors";
import { NoEncryption } from "@mui/icons-material";

function stableSort(array, comparator) {
  const stabilizedThis = array?.map((el, index) => [el, index]);
  stabilizedThis?.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) {
      return order;
    }
    return a[1] - b[1];
  });
  return stabilizedThis?.map((el) => el[0]);
}

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

const FilterOption = [
  {
    label: "All Data",
    isEnabled: "all",
    value: 1,
    key: 1,
  },
  {
    label: "ActiveData",
    isEnabled: "true",
    value: 2,
    key: 2,
  },
  {
    label: "In ActiveData",
    isEnabled: "false",
    value: 3,
    key: 3,
  },
];

const getClassName = (data) => {
  return data.status == "Active"
    ? "Active-chip"
    : data.status == "Inactive"
    ? " inActive-chip"
    : "";
};

const headCells = [
  {
    id: "company",
    placeMent: true,
    disablePadding: false,
    label: "Company Name",
  },
  {
    id: "location",
    placeMent: true,
    disablePadding: false,
    label: "Location",
  },
  {
    id: "remarks",
    placeMent: true,
    disablePadding: false,
    label: "Remarks",
  },
  {
    id: "RTOCode",
    placeMent: true,
    disablePadding: false,
    label: "RTO Code",
  },
  {
    id: "ActiveDate",
    placeMent: true,
    disablePadding: false,
    label: "Active Date",
  },
  {
    id: "DisableDate",
    placeMent: true,
    disablePadding: false,
    label: "Disable Date",
  },
  {
    id: "status",
    placeMent: true,
    disablePadding: false,
    label: "Status",
    class: getClassName,
  },
  // {
  //   id: "action",
  //   placeMent: false,
  //   disablePadding: false,
  //   label: "Action",
  // },
];

function EnhancedTableHead(props) {
  const { order, orderBy, onRequestSort } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        {headCells?.map((headCell) => (
          <TableCell
            className="TableHeader"
            key={headCell.id}
            align={headCell.placeMent ? "left" : "center"}
            padding={headCell.disablePadding ? "none" : "normal"}
            sortDirection={orderBy === headCell.id ? order : false}
            sx={{ fontSize: "16px", fontWeight: 600 }}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : "asc"}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <Box component="span" sx={visuallyHidden}>
                  {order === "desc" ? "sorted descending" : "sorted ascending"}
                </Box>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  onRequestSort: PropTypes.func.isRequired,
  order: PropTypes.oneOf(["asc", "desc"]).isRequired,
  orderBy: PropTypes.string.isRequired,
};

const RTOMapping = () => {
  const [order, setOrder] = React.useState("asc");
  const [orderBy, setOrderBy] = React.useState("id");
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [selectedData, setSelectedData] = React.useState({});
  const [openBranchDrawer, setOpenBranchDrawer] = React.useState(false);
  const [openConfirmBox, setOpenConfirmBox] = React.useState(false);
  const [openDeleteConfirmBox, setOpenDeleteConfirmBox] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [data, setData] = React.useState([]);
  const [searchText, setSearchText] = useState("");
  const [activeBoolean, setActiveBoolean] = useState();
  const [openLoader, setOpenLoader] = useState(false);
  const [pageView, setPageView] = useState(2);
  const [disabledDate, setDisabledDate] = useState("React-disable");
  const [tableConfig, setTableConfig] = useState({
    isAction: true,
    isEdit: true,
    isDelete: true,
    isSearch: true,
    isSwitch: true,
  });
  const [selectedTab, setSelectedTab] = useState(1);
  const [hoveredRTO, setHoveredRTO] = useState(null);
  const [formType, setFormType] = useState("");
  const [filter, setFilter] = useState({
    fn: (items) => {
      return items;
    },
  });

  const disableRTOMapping = (selectedDate) => {
    console.log("selectedData :", selectedData);
    // return true;
    UpdateCompanyRTO(selectedData._id, {
      isEnabled: false,
      disableDate: selectedDate,
    }).then((res) => {
      console.log(pageView);
      setOpenConfirmBox(false);
      switch (pageView) {
        case 1:
          GetData();
          break;
        case 2:
          GetActiveData();
          break;
        case 3:
          GetInActiveData();
          break;
        default:
          break;
      }
    });
  };

  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);
    console.log(newValue, "VS");
    const selectedOption = FilterOption.find(
      (option) => option.value === newValue
    );
    if (selectedOption.value === 1) {
      GetData();
    } else if (selectedOption.value === 2) {
      GetActiveData();
    } else if (selectedOption.value === 3) {
      GetInActiveData();
    }
  };

  const FilteredData = data.filter((el) => {
    console.log("Element:", el);
    return `${el?.company},${el?.RTOCode},${el?.remarks}`
      .toLowerCase()
      .includes(searchText.toLowerCase());
  });

  const visibleRows = React.useMemo(
    () =>
      stableSort(filter.fn(data), getComparator(order, orderBy))?.slice(
        page * rowsPerPage,
        page * rowsPerPage + rowsPerPage
      ),
    [order, orderBy, page, rowsPerPage, filter, data]
  );

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - data.length) : 0;

  const GetData = () => {
    GetCompanyRTO().then((res) => {
      const updatedData = res?.data.map((item) => ({
        ...item,
        ActiveDate: moment(item?.activeDate).format("DD/MM/YYYY"),
        DisableDate: item?.disableDate
          ? moment(item?.disableDate).format("DD/MM/YYYY")
          : "--",
        RTOCode: Array.isArray(item.RTOCode) ? (
          <>
            {item.RTOCode.slice(0, 4).join(" , ")}
            {item.RTOCode.length > 4 && (
              <Tooltip
                title={
                  <div className="tooltip-content">
                    {item.RTOCode.join(", ")}
                  </div>
                }
              >
                <span className="tooltip-button">
                  +{item.RTOCode.length - 4}
                </span>
              </Tooltip>
            )}
          </>
        ) : (
          ""
        ),
        status: item.isEnabled ? "Active" : "Inactive",
      }));
      setData(updatedData);
    });
  };

  const disableData = (row) => {
    setDisabledDate("React-disable");
    setOpenConfirmBox(true);
    setSelectedData(row);
  };

  const GetActiveData = async () => {
    setLoading(true);
    try {
      const res = await GetCompanyRTO();
      const updatedData = res?.data.map((item) => ({
        ...item,
        ActiveDate: moment(item?.activeDate).format("DD/MM/YYYY"),
        DisableDate: item?.disableDate
          ? moment(item?.disableDate).format("DD/MM/YYYY")
          : "--",
        RTOCode: Array.isArray(item.RTOCode) ? (
          <>
            {item.RTOCode.slice(0, 4).join(" , ")}
            {item.RTOCode.length > 4 && (
              <Tooltip
                title={
                  <div className="tooltip-content">
                    {item.RTOCode.join(", ")}
                  </div>
                }
              >
                <span className="tooltip-button">
                  +{item.RTOCode.length - 4}
                </span>
              </Tooltip>
            )}
          </>
        ) : (
          ""
        ),
        status: item.isEnabled ? "Active" : "Inactive",
      }));

      // ✅ Filter only active items
      setData(updatedData.filter((item) => item.isEnabled === true));
    } catch (error) {
      console.error("Error fetching active data:", error);
    } finally {
      setLoading(false); // ✅ Ensures loading is always set to false
    }
  };
  const GetInActiveData = async () => {
    setLoading(true);
    try {
      const res = await GetCompanyRTO();
      const updatedData = res?.data.map((item) => ({
        ...item,
        ActiveDate: moment(item?.activeDate).format("DD/MM/YYYY"),
        DisableDate: item?.disableDate
          ? moment(item?.disableDate).format("DD/MM/YYYY")
          : "--",
        RTOCode: Array.isArray(item.RTOCode) ? (
          <>
            {item.RTOCode.slice(0, 4).join(" , ")}
            {item.RTOCode.length > 4 && (
              <Tooltip
                title={
                  <div className="tooltip-content">
                    {item.RTOCode.join(", ")}
                  </div>
                }
              >
                <span className="tooltip-button">
                  +{item.RTOCode.length - 4}
                </span>
              </Tooltip>
            )}
          </>
        ) : (
          ""
        ),
        status: item.isEnabled ? "Active" : "Inactive",
      }));

      // ✅ Filter only inactive items
      setData(updatedData.filter((item) => item.isEnabled === false));
    } catch (error) {
      console.error("Error fetching inactive data:", error);
    } finally {
      setLoading(false); // ✅ Ensures loading state is reset
    }
  };

  React.useEffect(() => {
    GetData();
  }, []);

  const EditRtoData = (row) => {
    GetCompanyRTOByID(row._id)
      .then((res) => {
        setSelectedData(res.data);
      })
      .then(() => {
        setOpenBranchDrawer(true);
      });
  };

  const CreateRtoMapingData = () => {
    setSelectedData({});
    setOpenBranchDrawer(true);
    setFormType("add");
  };

  const ActiveBranchData = (row, active) => {
    setOpenConfirmBox(true);
    setSelectedData(row);
    setActiveBoolean(!active);
  };
  const ActiveFunction = (event) => {
    UpdateCompanyRTO(selectedData._id, { isEnabled: activeBoolean }).then(
      (res) => {
        console.log(pageView);
        switch (pageView) {
          case 1:
            GetData();
            break;
          case 2:
            GetActiveData();
            break;
          case 3:
            GetInActiveData();
            break;
          default:
            break;
        }
      }
    );

    setOpenConfirmBox(false);
  };

  const DeleteBranchData = (row) => {
    setOpenDeleteConfirmBox(true);
    setSelectedData(row);
  };
  const DeleteFunction = () => {
    DeleteRTO(selectedData._id).then((res) => {
      switch (pageView) {
        case 1:
          GetData();
          break;
        case 2:
          GetActiveData();
          break;
        case 3:
          GetInActiveData();
          break;
        default:
          break;
      }
      setOpenDeleteConfirmBox(false);
    });
  };
  const onSearch = (e) => {
    let target = e.target;
    setFilter({
      fn: (items) => {
        if (target.value == "") return items;
        else
          return items.filter((el) =>
            `${el.company},${el.location}`
              .toLowerCase()
              .includes(target.value.toLowerCase())
          );
      },
    });
    setPage(0);
  };

  const FilterRTOFunction = (e) => {
    setPageView(e?.key);
    let data = e?.isEnabled;
    console.log(e);
    let requesttype = e.value;
    let apiMethod =
      data === "all"
        ? GetData()
        : GetCompanyRTO(requesttype).then((res) => {
            setData(res?.data);
            const updatedData = res?.data.map((item) => ({
              ...item,
              RTOCode: Array.isArray(item.RTOCode) ? (
                <span
                  title={item.RTOCode.join(", ")}
                  style={{ cursor: "pointer" }}
                >
                  {item.RTOCode.slice(0, 4).join(" , ")}
                  {item.RTOCode.length > 4 && (
                    <span
                      style={{
                        backgroundColor: "gray",
                        color: "black",
                        padding: "2px 4px 2px 4px",
                        borderRadius: "4px",
                        marginLeft: "5px",
                      }}
                    >
                      +{item.RTOCode.length - 4}
                    </span>
                  )}
                </span>
              ) : (
                ""
              ),
              status: item.isEnabled ? "Active" : "Inactive",
            }));
            setData(updatedData);
          });
    setPage(0);
  };

  return (
    <>
      <Grid container className="Master_Card_Container">
        <Grid
          container
          alignItems={"center"}
          className="Master_Card_Sub_Container"
        >
          <Grid item xs={12} sm={6} md={6}>
            <Typography className="Master_Card_Tittle">RTO Mapping</Typography>
          </Grid>
          <Grid
            item
            xs={12}
            sm={6}
            md={6}
            className="d-flex justify-content-end"
          >
            <Button
              className="Master_Card_create_Button w-100"
              startIcon={
                <AddIcon
                  sx={{
                    marginRight: "1.5px",
                  }}
                />
              }
              onClick={() => CreateRtoMapingData()}
            >
              Create
            </Button>
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <Divider
            sx={{
              backgroundColor: "#EAECF0",
              borderWidth: 1,
            }}
          />
        </Grid>
        <Grid
          container
          alignItems={"center"}
          justifyContent={"space-between"}
          className="Master_Card_Sub_Container"
        >
          <TabFilter
            options={FilterOption}
            selectedTab={selectedTab}
            onTabChange={handleTabChange}
          />
          <Grid item xs={12} sm={4} md={3.1} mt={{ xs: 2, sm: 0, md: 0 }}>
            <Input
              focused="false"
              className="w-100 Master_Card_Input"
              id="standard-adornment-password"
              // onChange={onSearch}
              onChange={(e) => {
                setSearchText(e.target.value);
                setPage(0);
              }}
              disableUnderline={true}
              placeholder="Search in RTO Mapping"
              startAdornment={
                <InputAdornment position="start" sx={{ marginRight: "0px" }}>
                  <IconButton aria-label="toggle password visibility">
                    <SearchIcon
                      sx={{
                        fontSize: "20px",
                      }}
                    />
                  </IconButton>
                </InputAdornment>
              }
            />
          </Grid>
        </Grid>
        <MasterCommonTable
          tableConfig={tableConfig}
          data={FilteredData}
          columns={headCells}
          loading={loading}
          handleEdit={EditRtoData}
          handleDelete={DeleteBranchData}
          handleApprove={ActiveBranchData}
          tableTotalCount={filter.fn(data)?.length || 0}
        />
      </Grid>

      <AnimatePresence>
        {openBranchDrawer && (
          <Dialog
            open={openBranchDrawer}
            keepMounted
            aria-describedby="alert-dialog-slide-description"
            PaperProps={{
              sx: {
                maxWidth: {
                  xs: "80%",
                  sm: "70%",
                  md: "50%",
                  lg: "40%",
                },
              },
            }}
            BackdropProps={{
              style: {
                backdropFilter: "blur(5px)",
                backgroundColor: "rgba(0, 0, 0, 0.2)",
              },
            }}
          >
            <motion.div
              initial={{ opacity: 0, scale: 0.95 }}
              animate={{ opacity: 1, scale: 1 }}
              exit={{ opacity: 0, scale: 0.95 }}
              transition={{ duration: 0.2, ease: "easeInOut" }}
            >
              {openBranchDrawer ? (
                <AddRTOMapping
                  title={selectedData._id ? "Edit" : "Create"}
                  selectedData={selectedData}
                  formType={selectedData._id ? "edit" : "add"}
                  setOpenBranchDrawer={setOpenBranchDrawer}
                  GetActiveData={GetActiveData}
                  GetData={GetData}
                  setSelectedData={setSelectedData}
                />
              ) : null}
            </motion.div>
          </Dialog>
        )}
      </AnimatePresence>

      <ConfirmBox
        open={openConfirmBox}
        title={selectedData.isEnabled ? "Inactive" : "Active"}
        content={`Are you sure want to ${
          selectedData.isEnabled ? "Inactive" : "Active"
        }`}
        confirmButton={selectedData.isEnabled ? "Inactive" : "Active"}
        setOpenConfirmBox={setOpenConfirmBox}
        Function={ActiveFunction}
        icon={
          selectedData.isEnabled ? <NotInterestedIcon /> : <DoneOutlineIcon />
        }
        // color={selectedData.isEnabled ? "error" : "success"}
        img={selectedData.isEnabled ? DisabledImage : ActiveImage}
        color={selectedData.isEnabled ? "error" : "bule"}
        subContent={
          selectedData.isEnabled
            ? "This action will disable the item, and it won't be accessible until reactivated."
            : "Once activated, this item will be accessible. You can disable it later if needed."
        }
      />

      <ConfirmBox
        open={openDeleteConfirmBox}
        title="Delete"
        content="Are you sure you want to delete this?"
        subContent="This action cannot be undone. Once deleted, the data will be permanently removed from the system."
        img={DeleteImage}
        confirmButton="Delete"
        setOpenConfirmBox={setOpenDeleteConfirmBox}
        Function={DeleteFunction}
        icon={<DeleteIcon />}
        color="error"
      />

      <ConfirmBox
        setDisabledDate={setDisabledDate}
        disabledDate={disabledDate}
        mode="picker"
        open={openConfirmBox}
        title="Disable"
        content={
          disabledDate === "React-disable"
            ? "Please select the date ... !"
            : "Are you sure want to disable"
        }
        confirmButton="Disable"
        setOpenConfirmBox={setOpenConfirmBox}
        Function={disableRTOMapping}
        icon={<NotInterestedIcon />}
        color="error"
      />
      <Loader open={openLoader} />
    </>
  );
};
export default RTOMapping;
